// extracted by mini-css-extract-plugin
module.exports = {"teaser":"teaser_teaser__qr13P"};